import React from 'react';
import { Modal } from 'react-bootstrap';
import DataGrid, { Column } from 'devextreme-react/data-grid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { getTextFromList } from './services/buildPayload';

interface ViewRawMaterialModalProps {
    show: boolean;
    onClose: () => void;
    rawMaterials: any[];
    dropdowns: any;
    onDelete: (id: string) => void;
}

const ViewRawMaterialModal: React.FC<ViewRawMaterialModalProps> = ({
    show,
    onClose,
    rawMaterials,
    dropdowns,
    onDelete
}) => {
    return (
        <div>
            <Modal
                show={show}
                onHide={onClose}
                backdrop="static"
                size="lg"
                dialogClassName="modal-dialog-centered"
                style={{ backgroundColor: `rgba(0, 0, 0, 0.4)` }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Raw Materials</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {rawMaterials.length > 0 ? (
                        <DataGrid
                            dataSource={rawMaterials}
                            showRowLines
                            showBorders
                            keyExpr="id"
                        >
                            <Column
                                caption="Action"
                                width={80}
                                cellRender={({ data }) => (
                                    <button
                                        type="button"
                                        className="btn btn-sm action-btn delete-btn"
                                        title="Delete"
                                        onClick={() => onDelete(data.id)}
                                    >
                                        <FontAwesomeIcon icon={faTrash} />
                                    </button>
                                )}
                            />
                            <Column dataField="rowType" caption="Type" width={120}
                                cellRender={({ data }) => (
                                    <span>{getTextFromList(data.rowType, dropdowns.rowMaterialTypeList)}</span>
                                )}
                            />
                            <Column dataField="weight" caption="Gross Weight" width={150} />
                            <Column
                                dataField="rawkarat"
                                caption="Karat"
                                width={100}
                                cellRender={({ data }) => (
                                    <span>{getTextFromList(data.rawkarat, dropdowns.karat)}</span>
                                )}
                            />
                            <Column dataField="qty" caption="Quantity" width={100} />
                            <Column dataField="stoneWeight" caption="Stone Weight" width={120} />
                            <Column dataField="mf" caption="MF" width={80} />
                        </DataGrid>
                    ) : (
                        <p className="text-center text-muted my-3">No raw materials added</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn add-btn" onClick={onClose}>
                        Close
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default ViewRawMaterialModal;